// Currency format lookup table to avoid repeated API calls
// Format: { "iso-currency": { template, options, currencyDisplays } }
const CURRENCY_FORMATS = {
    // English - United States
    'en-US-USD': {
        template: '{{currency}}{{value}}',
        options: {
            currency: '$',
            decimal: '.',
            group: ',',
        },
        currencyDisplays: {
            USD: '$',
            EUR: '€',
            GBP: '£',
            JPY: '¥',
            CAD: 'CA$',
            AUD: 'AU$',
        },
    },
    'en-US-EUR': {
        template: '{{currency}}{{value}}',
        options: {
            currency: '€',
            decimal: '.',
            group: ',',
        },
        currencyDisplays: {
            USD: '$',
            EUR: '€',
            GBP: '£',
            JPY: '¥',
            CAD: 'CA$',
            AUD: 'AU$',
        },
    },
    'en-US-GBP': {
        template: '{{currency}}{{value}}',
        options: {
            currency: '£',
            decimal: '.',
            group: ',',
        },
        currencyDisplays: {
            USD: '$',
            EUR: '€',
            GBP: '£',
            JPY: '¥',
            CAD: 'CA$',
            AUD: 'AU$',
        },
    },

    // English - United Kingdom
    'en-GB-GBP': {
        template: '{{currency}}{{value}}',
        options: {
            currency: '£',
            decimal: '.',
            group: ',',
        },
        currencyDisplays: {
            USD: '$',
            EUR: '€',
            GBP: '£',
            JPY: '¥',
            CAD: 'CA$',
            AUD: 'AU$',
        },
    },
    'en-GB-EUR': {
        template: '{{currency}}{{value}}',
        options: {
            currency: '€',
            decimal: '.',
            group: ',',
        },
        currencyDisplays: {
            USD: '$',
            EUR: '€',
            GBP: '£',
            JPY: '¥',
            CAD: 'CA$',
            AUD: 'AU$',
        },
    },
    'en-GB-USD': {
        template: '{{currency}}{{value}}',
        options: {
            currency: '$',
            decimal: '.',
            group: ',',
        },
        currencyDisplays: {
            USD: '$',
            EUR: '€',
            GBP: '£',
            JPY: '¥',
            CAD: 'CA$',
            AUD: 'AU$',
        },
    },

    // German - Germany
    'de-DE-EUR': {
        template: '{{value}} {{currency}}',
        options: {
            currency: '€',
            decimal: ',',
            group: '.',
        },
        currencyDisplays: {
            USD: '$',
            EUR: '€',
            GBP: '£',
            JPY: '¥',
            CAD: 'CA$',
            AUD: 'AU$',
        },
    },
    'de-DE-USD': {
        template: '{{value}} {{currency}}',
        options: {
            currency: '$',
            decimal: ',',
            group: '.',
        },
        currencyDisplays: {
            USD: '$',
            EUR: '€',
            GBP: '£',
            JPY: '¥',
            CAD: 'CA$',
            AUD: 'AU$',
        },
    },
    'de-DE-GBP': {
        template: '{{value}} {{currency}}',
        options: {
            currency: '£',
            decimal: ',',
            group: '.',
        },
        currencyDisplays: {
            USD: '$',
            EUR: '€',
            GBP: '£',
            JPY: '¥',
            CAD: 'CA$',
            AUD: 'AU$',
        },
    },

    // French - France
    'fr-FR-EUR': {
        template: '{{value}} {{currency}}',
        options: {
            currency: '€',
            decimal: ',',
            group: ' ',
        },
        currencyDisplays: {
            USD: '$US',
            EUR: '€',
            GBP: '£',
            JPY: '¥',
            CAD: '$CA',
            AUD: '$AU',
        },
    },
    'fr-FR-USD': {
        template: '{{value}} {{currency}}',
        options: {
            currency: '$US',
            decimal: ',',
            group: ' ',
        },
        currencyDisplays: {
            USD: '$US',
            EUR: '€',
            GBP: '£',
            JPY: '¥',
            CAD: '$CA',
            AUD: '$AU',
        },
    },
    'fr-FR-GBP': {
        template: '{{value}} {{currency}}',
        options: {
            currency: '£',
            decimal: ',',
            group: ' ',
        },
        currencyDisplays: {
            USD: '$US',
            EUR: '€',
            GBP: '£',
            JPY: '¥',
            CAD: '$CA',
            AUD: '$AU',
        },
    },

    // Spanish - Spain
    'es-ES-EUR': {
        template: '{{value}} {{currency}}',
        options: {
            currency: '€',
            decimal: ',',
            group: '.',
        },
        currencyDisplays: {
            USD: '$',
            EUR: '€',
            GBP: '£',
            JPY: '¥',
            CAD: 'CA$',
            AUD: 'AU$',
        },
    },
    'es-ES-USD': {
        template: '{{value}} {{currency}}',
        options: {
            currency: '$',
            decimal: ',',
            group: '.',
        },
        currencyDisplays: {
            USD: '$',
            EUR: '€',
            GBP: '£',
            JPY: '¥',
            CAD: 'CA$',
            AUD: 'AU$',
        },
    },
    'es-ES-GBP': {
        template: '{{value}} {{currency}}',
        options: {
            currency: '£',
            decimal: ',',
            group: '.',
        },
        currencyDisplays: {
            USD: '$',
            EUR: '€',
            GBP: '£',
            JPY: '¥',
            CAD: 'CA$',
            AUD: 'AU$',
        },
    },

    // Italian - Italy
    'it-IT-EUR': {
        template: '{{value}} {{currency}}',
        options: {
            currency: '€',
            decimal: ',',
            group: '.',
        },
        currencyDisplays: {
            USD: '$',
            EUR: '€',
            GBP: '£',
            JPY: '¥',
            CAD: 'CA$',
            AUD: 'AU$',
        },
    },
    'it-IT-USD': {
        template: '{{value}} {{currency}}',
        options: {
            currency: '$',
            decimal: ',',
            group: '.',
        },
        currencyDisplays: {
            USD: '$',
            EUR: '€',
            GBP: '£',
            JPY: '¥',
            CAD: 'CA$',
            AUD: 'AU$',
        },
    },
    'it-IT-GBP': {
        template: '{{value}} {{currency}}',
        options: {
            currency: '£',
            decimal: ',',
            group: '.',
        },
        currencyDisplays: {
            USD: '$',
            EUR: '€',
            GBP: '£',
            JPY: '¥',
            CAD: 'CA$',
            AUD: 'AU$',
        },
    },

    // Dutch - Netherlands
    'nl-NL-EUR': {
        template: '{{currency}} {{value}}',
        options: {
            currency: '€',
            decimal: ',',
            group: '.',
        },
        currencyDisplays: {
            USD: '$',
            EUR: '€',
            GBP: '£',
            JPY: '¥',
            CAD: 'CA$',
            AUD: 'AU$',
        },
    },
    'nl-NL-USD': {
        template: '{{currency}} {{value}}',
        options: {
            currency: '$',
            decimal: ',',
            group: '.',
        },
        currencyDisplays: {
            USD: '$',
            EUR: '€',
            GBP: '£',
            JPY: '¥',
            CAD: 'CA$',
            AUD: 'AU$',
        },
    },
    'nl-NL-GBP': {
        template: '{{currency}} {{value}}',
        options: {
            currency: '£',
            decimal: ',',
            group: '.',
        },
        currencyDisplays: {
            USD: '$',
            EUR: '€',
            GBP: '£',
            JPY: '¥',
            CAD: 'CA$',
            AUD: 'AU$',
        },
    },

    // Japanese - Japan
    'ja-JP-JPY': {
        template: '{{currency}}{{value}}',
        options: {
            currency: '¥',
            decimal: null,
            group: ',',
        },
        currencyDisplays: {
            USD: '$',
            EUR: '€',
            GBP: '£',
            JPY: '¥',
            CAD: 'CA$',
            AUD: 'AU$',
        },
    },
    'ja-JP-USD': {
        template: '{{currency}}{{value}}',
        options: {
            currency: '$',
            decimal: '.',
            group: ',',
        },
        currencyDisplays: {
            USD: '$',
            EUR: '€',
            GBP: '£',
            JPY: '¥',
            CAD: 'CA$',
            AUD: 'AU$',
        },
    },
    'ja-JP-EUR': {
        template: '{{currency}}{{value}}',
        options: {
            currency: '€',
            decimal: '.',
            group: ',',
        },
        currencyDisplays: {
            USD: '$',
            EUR: '€',
            GBP: '£',
            JPY: '¥',
            CAD: 'CA$',
            AUD: 'AU$',
        },
    },

    // Portuguese - Portugal
    'pt-PT-EUR': {
        template: '{{value}} {{currency}}',
        options: {
            currency: '€',
            decimal: ',',
            group: ' ',
        },
        currencyDisplays: {
            USD: '$',
            EUR: '€',
            GBP: '£',
            JPY: '¥',
            CAD: 'CA$',
            AUD: 'AU$',
        },
    },
    'pt-PT-USD': {
        template: '{{value}} {{currency}}',
        options: {
            currency: '$',
            decimal: ',',
            group: ' ',
        },
        currencyDisplays: {
            USD: '$',
            EUR: '€',
            GBP: '£',
            JPY: '¥',
            CAD: 'CA$',
            AUD: 'AU$',
        },
    },
    'pt-PT-GBP': {
        template: '{{value}} {{currency}}',
        options: {
            currency: '£',
            decimal: ',',
            group: ' ',
        },
        currencyDisplays: {
            USD: '$',
            EUR: '€',
            GBP: '£',
            JPY: '¥',
            CAD: 'CA$',
            AUD: 'AU$',
        },
    },

    // Polish - Poland
    'pl-PL-PLN': {
        template: '{{value}} {{currency}}',
        options: {
            currency: 'zł',
            decimal: ',',
            group: ' ',
        },
        currencyDisplays: {
            USD: '$',
            EUR: '€',
            GBP: '£',
            JPY: '¥',
            PLN: 'zł',
            CAD: 'CA$',
            AUD: 'AU$',
        },
    },
    'pl-PL-EUR': {
        template: '{{value}} {{currency}}',
        options: {
            currency: '€',
            decimal: ',',
            group: ' ',
        },
        currencyDisplays: {
            USD: '$',
            EUR: '€',
            GBP: '£',
            JPY: '¥',
            PLN: 'zł',
            CAD: 'CA$',
            AUD: 'AU$',
        },
    },
    'pl-PL-USD': {
        template: '{{value}} {{currency}}',
        options: {
            currency: '$',
            decimal: ',',
            group: ' ',
        },
        currencyDisplays: {
            USD: '$',
            EUR: '€',
            GBP: '£',
            JPY: '¥',
            PLN: 'zł',
            CAD: 'CA$',
            AUD: 'AU$',
        },
    },

    // Swedish - Sweden
    'sv-SE-SEK': {
        template: '{{value}} {{currency}}',
        options: {
            currency: 'kr',
            decimal: ',',
            group: ' ',
        },
        currencyDisplays: {
            USD: '$',
            EUR: '€',
            GBP: '£',
            JPY: '¥',
            SEK: 'kr',
            CAD: 'CA$',
            AUD: 'AU$',
        },
    },
    'sv-SE-EUR': {
        template: '{{value}} {{currency}}',
        options: {
            currency: '€',
            decimal: ',',
            group: ' ',
        },
        currencyDisplays: {
            USD: '$',
            EUR: '€',
            GBP: '£',
            JPY: '¥',
            SEK: 'kr',
            CAD: 'CA$',
            AUD: 'AU$',
        },
    },
    'sv-SE-USD': {
        template: '{{value}} {{currency}}',
        options: {
            currency: '$',
            decimal: ',',
            group: ' ',
        },
        currencyDisplays: {
            USD: '$',
            EUR: '€',
            GBP: '£',
            JPY: '¥',
            SEK: 'kr',
            CAD: 'CA$',
            AUD: 'AU$',
        },
    },

    // Additional European markets using EUR
    'sk-SK-EUR': {
        template: '{{value}} {{currency}}',
        options: {
            currency: '€',
            decimal: ',',
            group: ' ',
        },
        currencyDisplays: {
            USD: '$',
            EUR: '€',
            GBP: '£',
            JPY: '¥',
            CAD: 'CA$',
            AUD: 'AU$',
        },
    },
    'hr-HR-EUR': {
        template: '{{value}} {{currency}}',
        options: {
            currency: '€',
            decimal: ',',
            group: '.',
        },
        currencyDisplays: {
            USD: '$',
            EUR: '€',
            GBP: '£',
            JPY: '¥',
            CAD: 'CA$',
            AUD: 'AU$',
        },
    },
    'de-AT-EUR': {
        template: '{{currency}} {{value}}',
        options: {
            currency: '€',
            decimal: ',',
            group: '.',
        },
        currencyDisplays: {
            USD: '$',
            EUR: '€',
            GBP: '£',
            JPY: '¥',
            CAD: 'CA$',
            AUD: 'AU$',
        },
    },
    'lv-LV-EUR': {
        template: '{{currency}} {{value}}',
        options: {
            currency: '€',
            decimal: ',',
            group: ' ',
        },
        currencyDisplays: {
            USD: '$',
            EUR: '€',
            GBP: '£',
            JPY: '¥',
            CAD: 'CA$',
            AUD: 'AU$',
        },
    },
    'lt-LT-EUR': {
        template: '{{value}} {{currency}}',
        options: {
            currency: '€',
            decimal: ',',
            group: ' ',
        },
        currencyDisplays: {
            USD: '$',
            EUR: '€',
            GBP: '£',
            JPY: '¥',
            CAD: 'CA$',
            AUD: 'AU$',
        },
    },
    'mt-MT-EUR': {
        template: '{{currency}}{{value}}',
        options: {
            currency: '€',
            decimal: '.',
            group: ',',
        },
        currencyDisplays: {
            USD: '$',
            EUR: '€',
            GBP: '£',
            JPY: '¥',
            CAD: 'CA$',
            AUD: 'AU$',
        },
    },
    'fi-FI-EUR': {
        template: '{{value}} {{currency}}',
        options: {
            currency: '€',
            decimal: ',',
            group: ' ',
        },
        currencyDisplays: {
            USD: '$',
            EUR: '€',
            GBP: '£',
            JPY: '¥',
            SEK: 'kr',
            CAD: 'CA$',
            AUD: 'AU$',
        },
    },
    'bg-BG-EUR': {
        template: '{{value}} {{currency}}',
        options: {
            currency: '€',
            decimal: ',',
            group: ' ',
        },
        currencyDisplays: {
            USD: '$',
            EUR: '€',
            GBP: '£',
            JPY: '¥',
            CAD: 'CA$',
            AUD: 'AU$',
        },
    },
    'fr-LU-EUR': {
        template: '{{value}} {{currency}}',
        options: {
            currency: '€',
            decimal: ',',
            group: '.',
        },
        currencyDisplays: {
            USD: '$',
            EUR: '€',
            GBP: '£',
            JPY: '¥',
            CAD: 'CA$',
            AUD: 'AU$',
        },
    },
    'nl-BE-EUR': {
        template: '{{value}} {{currency}}',
        options: {
            currency: '€',
            decimal: ',',
            group: '.',
        },
        currencyDisplays: {
            USD: '$',
            EUR: '€',
            GBP: '£',
            JPY: '¥',
            CAD: 'CA$',
            AUD: 'AU$',
        },
    },
    'fr-BE-EUR': {
        template: '{{value}} {{currency}}',
        options: {
            currency: '€',
            decimal: ',',
            group: ' ',
        },
        currencyDisplays: {
            USD: '$',
            EUR: '€',
            GBP: '£',
            JPY: '¥',
            CAD: 'CA$',
            AUD: 'AU$',
        },
    },
    'en-IE-EUR': {
        template: '{{currency}}{{value}}',
        options: {
            currency: '€',
            decimal: '.',
            group: ',',
        },
        currencyDisplays: {
            USD: '$',
            EUR: '€',
            GBP: '£',
            JPY: '¥',
            CAD: 'CA$',
            AUD: 'AU$',
        },
    },

    // Mexico - Mexican Peso
    'es-MX-MXN': {
        template: '{{currency}}{{value}}',
        options: {
            currency: '$',
            decimal: '.',
            group: ',',
        },
        currencyDisplays: {
            MXN: '$',
            USD: 'US$',
            EUR: '€',
            GBP: '£',
            JPY: '¥',
            CAD: 'CA$',
            AUD: 'AU$',
        },
    },

    // UAE - Dirham
    'ar-AE-AED': {
        template: '{{currency}} {{value}}',
        options: {
            currency: 'د.إ',
            decimal: '.',
            group: ',',
        },
        currencyDisplays: {
            AED: 'د.إ',
            USD: '$',
            EUR: '€',
            GBP: '£',
            JPY: '¥',
        },
    },

    // Switzerland - Swiss Franc
    'de-CH-CHF': {
        template: '{{currency}} {{value}}',
        options: {
            currency: 'CHF',
            decimal: '.',
            group: "'",
        },
        currencyDisplays: {
            CHF: 'CHF',
            USD: '$',
            EUR: '€',
            GBP: '£',
            JPY: '¥',
        },
    },
    'fr-CH-CHF': {
        template: '{{currency}} {{value}}',
        options: {
            currency: 'CHF',
            decimal: '.',
            group: ' ',
        },
        currencyDisplays: {
            CHF: 'CHF',
            USD: '$',
            EUR: '€',
            GBP: '£',
            JPY: '¥',
        },
    },
    'it-CH-CHF': {
        template: '{{currency}} {{value}}',
        options: {
            currency: 'CHF',
            decimal: '.',
            group: "'",
        },
        currencyDisplays: {
            CHF: 'CHF',
            USD: '$',
            EUR: '€',
            GBP: '£',
            JPY: '¥',
        },
    },

    // Canada - Canadian Dollar
    'en-CA-CAD': {
        template: '{{currency}}{{value}}',
        options: {
            currency: '$',
            decimal: '.',
            group: ',',
        },
        currencyDisplays: {
            CAD: '$',
            USD: 'US$',
            EUR: '€',
            GBP: '£',
            JPY: '¥',
        },
    },

    // Romania - Romanian Leu
    'ro-RO-RON': {
        template: '{{value}} {{currency}}',
        options: {
            currency: 'lei',
            decimal: ',',
            group: '.',
        },
        currencyDisplays: {
            RON: 'lei',
            USD: '$',
            EUR: '€',
            GBP: '£',
            JPY: '¥',
        },
    },

    // Hungary - Hungarian Forint
    'hu-HU-HUF': {
        template: '{{value}} {{currency}}',
        options: {
            currency: 'Ft',
            decimal: ',',
            group: ' ',
        },
        currencyDisplays: {
            HUF: 'Ft',
            USD: '$',
            EUR: '€',
            GBP: '£',
            JPY: '¥',
        },
    },

    // Norway - Norwegian Krone
    'nb-NO-NOK': {
        template: '{{currency}} {{value}}',
        options: {
            currency: 'kr',
            decimal: ',',
            group: ' ',
        },
        currencyDisplays: {
            NOK: 'kr',
            USD: '$',
            EUR: '€',
            GBP: '£',
            JPY: '¥',
            SEK: 'SEK',
            DKK: 'DKK',
        },
    },

    // Denmark - Danish Krone
    'da-DK-DKK': {
        template: '{{currency}} {{value}}',
        options: {
            currency: 'kr.',
            decimal: ',',
            group: '.',
        },
        currencyDisplays: {
            DKK: 'kr.',
            USD: '$',
            EUR: '€',
            GBP: '£',
            JPY: '¥',
            NOK: 'NOK',
            SEK: 'SEK',
        },
    },

    // Turkey - Turkish Lira
    'tr-TR-TRY': {
        template: '{{currency}}{{value}}',
        options: {
            currency: '₺',
            decimal: ',',
            group: '.',
        },
        currencyDisplays: {
            TRY: '₺',
            USD: '$',
            EUR: '€',
            GBP: '£',
            JPY: '¥',
        },
    },

    // Australia - Australian Dollar
    'en-AU-AUD': {
        template: '{{currency}}{{value}}',
        options: {
            currency: '$',
            decimal: '.',
            group: ',',
        },
        currencyDisplays: {
            AUD: '$',
            USD: 'US$',
            EUR: '€',
            GBP: '£',
            JPY: '¥',
            NZD: 'NZ$',
        },
    },

    // New Zealand - uses AUD
    'en-NZ-AUD': {
        template: '{{currency}}{{value}}',
        options: {
            currency: '$',
            decimal: '.',
            group: ',',
        },
        currencyDisplays: {
            AUD: 'AU$',
            NZD: '$',
            USD: 'US$',
            EUR: '€',
            GBP: '£',
            JPY: '¥',
        },
    },

    // Czech Republic - Czech Koruna
    'cs-CZ-CZK': {
        template: '{{value}} {{currency}}',
        options: {
            currency: 'Kč',
            decimal: ',',
            group: ' ',
        },
        currencyDisplays: {
            CZK: 'Kč',
            USD: '$',
            EUR: '€',
            GBP: '£',
            JPY: '¥',
        },
    },

    // Brazil - uses USD
    'pt-BR-USD': {
        template: '{{currency}} {{value}}',
        options: {
            currency: 'US$',
            decimal: ',',
            group: '.',
        },
        currencyDisplays: {
            USD: 'US$',
            BRL: 'R$',
            EUR: '€',
            GBP: '£',
            JPY: '¥',
        },
    },

    // India - uses USD
    'en-IN-USD': {
        template: '{{currency}}{{value}}',
        options: {
            currency: '$',
            decimal: '.',
            group: ',',
        },
        currencyDisplays: {
            USD: '$',
            INR: '₹',
            EUR: '€',
            GBP: '£',
            JPY: '¥',
        },
    },
};

// Cache for API responses to avoid repeated calls for unknown combinations
const apiCache = new Map();

export function getCurrencyFormatFromLookup(iso, currency) {
    const key = `${iso}-${currency}`;

    // First, check the static lookup table
    if (CURRENCY_FORMATS[key]) {
        return CURRENCY_FORMATS[key];
    }

    // Check if we have it cached from a previous API call
    if (apiCache.has(key)) {
        return apiCache.get(key);
    }

    // Return null to indicate we need to fetch from API
    return null;
}

export function setCurrencyFormatCache(iso, currency, format) {
    const key = `${iso}-${currency}`;
    apiCache.set(key, format);
}

export function getDefaultCurrencyFormat(currency = 'EUR') {
    // Return a sensible default format if all else fails
    const currencySymbols = {
        USD: '$',
        EUR: '€',
        GBP: '£',
        JPY: '¥',
        CAD: 'CA$',
        AUD: 'AU$',
        CHF: 'CHF',
        SEK: 'kr',
        NOK: 'kr',
        DKK: 'kr.',
        PLN: 'zł',
        MXN: '$',
        AED: 'د.إ',
        RON: 'lei',
        HUF: 'Ft',
        TRY: '₺',
        CZK: 'Kč',
        BRL: 'R$',
        INR: '₹',
        NZD: 'NZ$',
    };

    return {
        template: '{{currency}}{{value}}',
        options: {
            currency: currencySymbols[currency] || currency,
            decimal: '.',
            group: ',',
        },
        currencyDisplays: {
            USD: '$',
            EUR: '€',
            GBP: '£',
            JPY: '¥',
            CAD: 'CA$',
            AUD: 'AU$',
            CHF: 'CHF',
            SEK: 'kr',
            NOK: 'kr',
            DKK: 'kr.',
            PLN: 'zł',
            MXN: '$',
            AED: 'د.إ',
            RON: 'lei',
            HUF: 'Ft',
            TRY: '₺',
            CZK: 'Kč',
            BRL: 'R$',
            INR: '₹',
            NZD: 'NZ$',
        },
    };
}
